module.exports = __webpack_public_path__ + "img/greyTick.755e867f.svg";